import { mapGetters, mapActions } from "vuex";
import Utils from "@/mixins/Utils";
import agencyService from "@/services/agency";
import pointage from "@/mixins/pointage";

export default {
    data: () => ({
        errorSupport: false,
        agency: {},
        showErrors: false,
        isSent: false,
        hasError: false
    }),
    mixins: [Utils, pointage],
    created() {
        this.getChargePlanning();
        this.getMyAgency()
        this.init();
        this.$root.$on('reset-support-form', this.resetForm);
    },
    beforeDestroy() {
        this.$root.$off('reset-support-form', this.resetForm);
    },
    computed: {
        ...mapGetters('supportTechnique', {
            reasons: 'reasons',
            appVersion: 'appVersion'
        }),
        isFormValid() {
            return !!(
                this.support.reason &&
                this.support.title &&
                this.support.message
            );
        },
    },
    methods: {
        ...mapActions('supportTechnique', {
            init: 'init',
            send: 'send',
            getAgencyInfo: 'getAgencyInfo'
        }),
        resetData() {
            this.support = {
                reason: undefined,
                title: undefined,
                message: undefined
            };
        },
        resetForm() {
            this.isSent = false;
            this.hasError = false;
            this.showErrors = false;
            this.resetData();
            if (this.$refs.formCard && this.$refs.formCard.$el) {
                this.$refs.formCard.$el.style.height = '';
            }
        },
        handleSubmit() {
            if (!this.isFormValid) {
                this.showErrors = true;
                return;
            }
            this.showErrors = false;
            if (this.$refs.formCard && this.$refs.formCard.$el) {
                this.$refs.formCard.$el.style.height = this.$refs.formCard.$el.offsetHeight + 'px';
            }
            this.submitTechniqueRequest();
        },
        handleRetry() {
            this.hasError = false;
            if (this.$refs.formCard && this.$refs.formCard.$el) {
                this.$refs.formCard.$el.style.height = '';
            }
        },
        async submitTechniqueRequest() {
            this.isSubmitting = true;
            const result = await this.$validator.validateAll();
            if (result) {
                try {
                    await this.send({
                        firstName: this.profile.firstName ? this.profile.firstName : '',
                        name: this.profile.name ? this.profile.name : '',
                        email: this.profile.email ? this.profile.email : '',
                        reason: this.support.reason ? this.support.reason : '',
                        title: this.support.title,
                        messages: this.support.message,
                        versionApp: this.appVersion,
                        agencyName: this.agency.name || '',
                        device: this.device,
                        browser: this.browser,
                        pkAdv: this.profile.pkAdv,
                        pointings: this.pointings
                    });
                    this.isSent = true;
                } catch (err) {
                    this.hasError = true;
                } finally {
                    this.isSubmitting = false;
                }
            }
        },
        async getMyAgency() {
            const vue = this;
            await agencyService
                .getAgence()
                .then((res) => {
                    vue.agency = res.data.agency || {};
                    this.getAgencyInfo(res.data.agency)
                })
                .catch((err) => {
                    // Handler error
                });
        }
    },
};
